import { THUMB_RADIUS_REM } from "./constants";

export const clamp = (v, min, max) => Math.min(Math.max(v, min), max);

export const formatTime = seconds => {
    if (!Number.isFinite(seconds) || seconds < 0) return "00:00";
    const total = Math.floor(seconds);
    const h = Math.floor(total / 3600);
    const m = String(Math.floor((total % 3600) / 60)).padStart(2, "0");
    const s = String(total % 60).padStart(2, "0");
    return h >= 1 ? `${h}:${m}:${s}` : `${m}:${s}`;
};
export const formatTagTime = seconds => formatTime(seconds).replace(/^0(?=\d:\d\d$)/, "");
export const formatRate = rate => `${Number.isInteger(rate) ? rate.toFixed(1) : rate}x`;
export const formatLabel = (tpl, vars) => tpl.replace(/\{([^{}]+)\}/g, (ph, key) => (vars[key] === undefined ? ph : String(vars[key])));

export const thumbOffset = percent => {
    const shift = (1 - percent / 50) * THUMB_RADIUS_REM;
    return `calc(${percent}% + ${Number(shift.toFixed(5))}rem)`;
};

export const volumeIcon = (volume, muted) => {
    if (muted || volume === 0) return "volume_off";
    if (volume < 0.34) return "volume_mute";
    if (volume < 0.67) return "volume_down";
    return "volume_up";
};
